import {createSelector} from 'reselect';

export const getState = (state) => state.setupStore;

export const getAdvSetupSelected = createSelector([getState], (setupStore) => setupStore.advSetupSelected);
export const getFontSize = createSelector([getState], (setupStore) => setupStore.fontSize);
export const getDefaultReturnValvePressure = createSelector(
  [getState],
  (setupStore) => setupStore.defaultReturnValvePressure,
);
export const getCurrentProfileParams = createSelector([getState], (setupStore) => setupStore.currentProfileParams);
export const getSaveAdvSetup = createSelector([getState], (setupStore) => setupStore.saveAdvSetup);
export const getButtonTypeAdv = createSelector([getState], (setupStore) => setupStore.buttonTypeAdv);
export const getRecoveryOfLiquid = createSelector([getState], (setupStore) => setupStore.recoveryOfLiquid);
export const getMembraneType = createSelector([getState], (setupStore) => setupStore.currentProfileParams.MembraneType);

export const getAdvanceCycleSetup = createSelector(
  [
    getAdvSetupSelected,
    getFontSize,
    getDefaultReturnValvePressure,
    getCurrentProfileParams,
    getSaveAdvSetup,
    getButtonTypeAdv,
    getRecoveryOfLiquid,
    getMembraneType,
  ],
  (
    advSetupSelected,
    fontSize,
    defaultReturnValvePressure,
    currentProfileParams,
    saveAdvSetup,
    buttonTypeAdv,
    recoveryOfLiquid,
    membraneType,
  ) => ({
    advSetupSelected,
    fontSize,
    defaultReturnValvePressure,
    currentProfileParams,
    saveAdvSetup,
    buttonTypeAdv,
    recoveryOfLiquid,
    membraneType,
  }),
);
